/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { useQuery, useMutation } from 'react-query'

import { getSaasUserMfaDevices, resetSaasUserMfa } from '@modules/mfa-api'
import { queryClient } from '@modules/query'
import type { ApiErrorCollection, QueryHookOptions } from '@modules/query/types'

// Re-export existing utilities
export * from './devices'
export * from './genericMessages'

/**
 * Hook to fetch MFA devices for a specific user
 */
export const useGetSaasUserMfaDevices = (userId: string, options?: QueryHookOptions) =>
  useQuery(['getSaasUserMfaDevices', userId], () => getSaasUserMfaDevices(userId), {
    ...options,
  })

/**
 * Hook to reset MFA for a specific user
 */
export const useResetSaasUserMfa = () =>
  useMutation<unknown, ApiErrorCollection, { userId: string; deviceId?: string }>(
    ({ userId, deviceId }) => resetSaasUserMfa(userId, deviceId),
    {
      onSuccess: (_, { userId }) => {
        // Invalidate the devices and okta groups query to trigger a refetch
        queryClient.invalidateQueries(['getSaasUserMfaDevices', userId])
        queryClient.invalidateQueries(['getSaasUserOktaGroups', userId])
      },
    },
  )
